import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Category } from '../models/category.model';
import { EgiftCardsUriService } from './e-gift-cards-uri.service';
import { OrderList, Product } from '../models/order-list.model';
import { DigitalProductReport } from '../models/digital-product-report.model';
import { ReportParams } from '../models/report-params.model';
import { ProductsResult } from '../models/product-result.model';
import { User } from 'src/app/shared/models/user.model';
interface QueryParams {
  key: string;
  value: string;
}

@Injectable({
  providedIn: 'root'
})



export class EgiftCardsGatewayService {

  constructor(private eGiftCardsUriService: EgiftCardsUriService, private http: HttpClient) { }

  getCategories(filters?): Observable<Category[]> {
    let params = new HttpParams();

    for(const filter in filters) {
      if(filters[filter]) {
        params = params.append(filter, filters[filter]);
      }
    }

    const url = this.eGiftCardsUriService.getCategoriesUri();
    return this.http.get<Category[]>(url, {params});
  }

  getProductList(limit: number, offset: number, query_params?: QueryParams[]): Observable<ProductsResult> {
    let params = new HttpParams();
    params = params.append('limit', limit.toString());
    params = params.append('offset', offset.toString());

    if (query_params) {
      for (let query of query_params) {
        params = params.append(query.key, query.value)
      }
    }

    const url = this.eGiftCardsUriService.getProductListUri();
    return this.http.get<ProductsResult>(url, { params });
  }

  getProductListByAdmin(query_params?: QueryParams[]): Observable<any> {
    let params = new HttpParams();

    if (query_params) {
      for (let query of query_params) {
        params = params.append(query.key, query.value)
      }
    }

    const url = this.eGiftCardsUriService.getProductListByAdmin();
    return this.http.get<any>(url, { params });
  }


  getOrders(filters?: any): Observable<OrderList> {
    let params = new HttpParams();

    for (let filter in filters) {
      params = params.append(filter, filters[filter]);
    }

    const url = this.eGiftCardsUriService.getOrdersUri();
    return this.http.get<OrderList>(url, { params });
  }
  
  getOrdersArchive(filters?: any): Observable<OrderList> {
    let params = new HttpParams();

    for (let filter in filters) {
      params = params.append(filter, filters[filter]);
    }

    const url = this.eGiftCardsUriService.getOrdersArchiveUri();
    return this.http.get<OrderList>(url, { params });
  }

  getOrdersByAdmin(filters: any) {
    let params = new HttpParams();

    for (let filter in filters) {
      params = params.append(filter, filters[filter])
    }

    const url = this.eGiftCardsUriService.getOrdersByAdminUri();
    return this.http.get<OrderList>(url, { params });


  }

  resendOrder(orderId: number, use_account_email: boolean = false, use_sub_user_email: boolean = false) {
    const url = this.eGiftCardsUriService.getResendOrdersUri(orderId);
    return this.http.post(url, { use_account_email, use_sub_user_email })
  }

  getReport(reportParams: ReportParams): Observable<DigitalProductReport> {
    let params = new HttpParams();
    if (reportParams) {
      for (let param in reportParams) {
        if (reportParams[param]) {
          params = params.append(param, reportParams[param]);
        }
      }
    }
    const url = this.eGiftCardsUriService.getReportUri();
    return this.http.get<DigitalProductReport>(url, { params })
  }

  getUserReport(reportParams: ReportParams): Observable<DigitalProductReport> {
    let params = new HttpParams();
    if (reportParams) {
      for (let param in reportParams) {
        if (reportParams[param]) {
          params = params.append(param, reportParams[param]);
        }
      }
    }
    const url = this.eGiftCardsUriService.getUserReportUri();
    return this.http.get<DigitalProductReport>(url, { params })
  }


  getUserDetail(userId: number): Observable<User> {
    const url = this.eGiftCardsUriService.getUserDetailUri(userId);
    return this.http.get<User>(url);
  }

  getProductDetail(productId: number): Observable<Product> {
    const url = this.eGiftCardsUriService.getProductDetailUri(productId);
    return this.http.get<Product>(url);
  }

  addToFavoriteSuggestions(productId: number): Observable<any> {
    const url = this.eGiftCardsUriService.getFavoriteSuggestionUri(productId);
    return this.http.post(url, {});
  }

  addToFavoriteProducts(productId: number): Observable<any> {
    const url = this.eGiftCardsUriService.getFavoriteProductUri(productId);
    return this.http.post(url, {});
  }

  removeFromFavoriteSuggestions(productId: number): Observable<any> {
    const url = this.eGiftCardsUriService.getFavoriteSuggestionUri(productId);
    return this.http.delete(url);
  }

  removeFromFavoriteProducts(productId: number): Observable<any> {
    const url = this.eGiftCardsUriService.getFavoriteProductUri(productId);
    return this.http.delete(url);
  }

  getFavoriteProducts(limit: number = 25, offset: number = 0, query_params?: QueryParams[]): Observable<any> {
    let params = new HttpParams();
    params = params.append('limit', limit.toString());
    params = params.append('offset', offset.toString());

    if (query_params) {
      for (let query of query_params) {
        params = params.append(query.key, query.value)
      }
    }
    const url = this.eGiftCardsUriService.getFavoriteProductsUri();
    return this.http.get<ProductsResult>(url, { params });

  }

  getFavoriteSuggestions(limit: number = 25, offset: number = 0, query_params?: QueryParams[]): Observable<any> {
    let params = new HttpParams();
    params = params.append('limit', limit.toString());
    params = params.append('offset', offset.toString());

    if (query_params) {
      for (let query of query_params) {
        params = params.append(query.key, query.value)
      }
    }
    const url = this.eGiftCardsUriService.getFavoriteSuggestionsUri();
    return this.http.get<any>(url, { params });

  }

  getCardSubjects(): Observable<any> {
    const url = this.eGiftCardsUriService.getCardSubjectsUri();
    return this.http.get<any>(url);
  }

  getProductDetailByRegion(id: number, query_params?: QueryParams[]): Observable<any> {
    let params = new HttpParams();
    if (query_params) {
      for (let query of query_params) {
        params = params.append(query.key, query.value)
      }
    }
    const url = this.eGiftCardsUriService.getProductDetailByRegionUri(id);
    return this.http.get<any>(url);
  }

  downloadOrderExcelFile(id, code): Observable<Blob> {

    const data = {
      google_auth_code: code
    };
    const url = this.eGiftCardsUriService.downloadOrderExcelUri(id);

    return this.http.post<Blob>(url, data, {
      responseType: 'blob' as 'json'
    })
  }

  downloadOrderReportExcelFile(filters): Observable<Blob> {
    let params = new HttpParams();
    const url = this.eGiftCardsUriService.downloadOrderReportExcelFile();
    for(let filter in filters) {
      params = params.append(filter, filters[filter]);
    }

    return this.http.get<Blob>(url, {params, responseType: 'blob' as 'json'});
  }

  
  searchByProductTitle(query_params?: QueryParams[]): Observable<Blob> {
   let params = new HttpParams();
    if (query_params) {
      for (let query of query_params) {
        params = params.append(query.key, query.value)
      }
    }
    const url = this.eGiftCardsUriService.searchByProductTitleUri();
    return this.http.get<any>(url, { params });
  }

  getPriceListProducts(priceListId: number, excel: number = 0): Observable<any> {
    let params = new HttpParams();
    params = params.append('excel', excel.toString());
    const url = this.eGiftCardsUriService.getPriceListProductsUri(priceListId);
    
    if (excel === 1) {
      return this.http.get<Blob>(url, { params, responseType: 'blob' as 'json' });
    }
    
    return this.http.get<any>(url, { params });
  }
}



